import { WayflyerSchemas } from "@wayflyer/api-types";

export const DEFAULT_MEMBER_ROLE: WayflyerSchemas.CompanyRole = "admin";

export const companyRoleLabels: Record<WayflyerSchemas.CompanyRole, string> = {
  admin: "Admin",
  financial_assistant: "Financial Assistant",
  user: "User",
};

export const companyRoleOptions = [
  { id: "admin", text: companyRoleLabels["admin"] },
  { id: "financial_assistant", text: companyRoleLabels["financial_assistant"] },
  { id: "user", text: companyRoleLabels["user"] },
];

const USER_PERMISSIONS = ["Manage funding applications", "Connect integrations"];
const MANAGE_BANK_ACCOUNTS_PERMISSION = "Create and delete bank accounts";
const FINANCIAL_ASSISTANT_PERMISSIONS = [
  ...USER_PERMISSIONS,
  MANAGE_BANK_ACCOUNTS_PERMISSION,
  "View payments and start payments that need approval",
];
const ADMIN_PERMISSIONS = [
  ...USER_PERMISSIONS,
  MANAGE_BANK_ACCOUNTS_PERMISSION,
  "View and make payments",
  "Edit team members' roles",
];

export const companyRolePermissionsMap: Record<WayflyerSchemas.CompanyRole, string[]> = {
  admin: ADMIN_PERMISSIONS,
  financial_assistant: FINANCIAL_ASSISTANT_PERMISSIONS,
  user: USER_PERMISSIONS,
};
